import type { DataDistributionContent } from "./contentItemSchemas";
import { parseImageContent } from "./image";
import { parseTextContent } from "./text";
import {
  dataDistributionBackgroundSchema,
  dataDistributionContentFieldsSchema,
  parseDataDistributionContentFromFields,
  parseWithRecord,
} from "./schemas";

export const parseDataDistributionContent = (
  item: unknown,
  formLabel?: string,
): DataDistributionContent => {
  const parsed = parseWithRecord(item, dataDistributionContentFieldsSchema);
  const label = parseImageContent(parsed.label);
  const question =
    parsed.question != null &&
    typeof parsed.question === "object" &&
    !Array.isArray(parsed.question)
      ? parseTextContent(parsed.question, "question")
      : undefined;
  const background =
    parsed.background != null &&
    typeof parsed.background === "object" &&
    !Array.isArray(parsed.background)
      ? parseWithRecord(parsed.background, dataDistributionBackgroundSchema)
      : undefined;
  return parseDataDistributionContentFromFields(
    parsed,
    formLabel,
    label,
    question,
    background,
  );
};
